import React from "react";
//import api from "../assets/icons/api.svg";
import connection from "../assets/icons/connection.svg";
import computer from "../assets/icons/computer.svg";
import SkillCard from "./SkillCard";
const skills = [
  {
    icon: computer,
    title: "Frontend Development",
    about:
      "I can build beautiful, responsive and scalable websites using Html, Css and Reactjs",
  },

  {
    icon: connection,
    title: "Machine Learning",
    about: "I can build machine learning models to manipulate data and get meaningful information",
  },
];

const About = () => {
  return (
    <div className="about">
      <h6 className="about__intro">
       Find meaning in what I do
      </h6>
      <div className="container about__container">
        <h6 className="about__heading">What I offer</h6>
        <div className="row">
          {skills.map((skill) => (
            <SkillCard skill={skill} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
